import { render, staticRenderFns } from "./Terastitcher.vue?vue&type=template&id=3571ca0f&scoped=true"
import script from "./Terastitcher.vue?vue&type=script&lang=js"
export * from "./Terastitcher.vue?vue&type=script&lang=js"
import style0 from "./Terastitcher.vue?vue&type=style&index=0&id=3571ca0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571ca0f",
  null
  
)

export default component.exports